<div class="prompts-panel">
  <miq-chat-bot-header
    [showBackBtn]="true"
    [showTitle]="false"
    [showCloseBtn]="false"
    [pageTitle]="'chat.allPrompts' | xTranslate"
    [windowSizeIncreased]="windowSizeIncreased"
    (emitWindowSize)="toggleWindowSize($event)"
    (emitNewSession)="startNewSession()"
  ></miq-chat-bot-header>
  <div class="prompts-panel-body">
    <ng-container *ngFor="let prompt of defaultPrompts | keyvalue">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="panel-title"> {{ prompt.key | titlecase }} </mat-panel-title>
        </mat-expansion-panel-header>

        <miq-chat-prompts [prompts]="prompt.value" (emitSelectedPrompt)="handlePromptClick($event)"></miq-chat-prompts>
      </mat-expansion-panel>
    </ng-container>
  </div>
</div>
